// cleanup with jsv-one-issue-table-spreadsheet-ui_ygrnf
/* eslint-disable no-param-reassign */
export const scrollToMiddle = (
	actions: {
		el: Element;
		top: number;
		left: number;
	}[],
) => {
	actions.forEach(({ el, top }) => {
		if (el.scrollTop === top) return;

		const halfVisibleHeight = el.clientHeight / 2;
		if (el.scrollTop > top) {
			el.scrollTop = top - halfVisibleHeight;
		} else {
			el.scrollTop = top + halfVisibleHeight;
		}
	});
};
/* eslint-enable no-param-reassign */
